import React from 'react';
import { MessageCircle } from 'lucide-react';

const WHATSAPP_CHAT_URL = 'https://wa.me/message/EPE5IIJCJKCAL1';

const FloatingWhatsAppWidget = () => {
  return (
    <a
      href={WHATSAPP_CHAT_URL}
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Start a WhatsApp chat with Kingdom Auto Detailing"
      data-testid="floating-whatsapp-chat-widget"
      className="fixed bottom-24 right-5 z-[60] flex items-center gap-3 rounded-full border border-emerald-300/40 bg-emerald-500 px-5 py-4 text-white shadow-2xl shadow-emerald-950/40 transition-[background-color,transform,box-shadow] duration-200 hover:-translate-y-1 hover:bg-emerald-400 hover:shadow-emerald-500/30 focus:outline-none focus:ring-2 focus:ring-emerald-200 focus:ring-offset-2 focus:ring-offset-black sm:right-8"
    >
      <span className="relative flex h-11 w-11 items-center justify-center rounded-full bg-white text-emerald-600">
        <MessageCircle size={26} strokeWidth={2.5} aria-hidden="true" />
        <span className="absolute -right-0.5 -top-0.5 h-3.5 w-3.5 rounded-full border-2 border-emerald-500 bg-lime-300" />
      </span>
      <span className="hidden text-left leading-tight sm:block">
        <span className="block text-xs font-semibold uppercase tracking-[0.22em] text-emerald-950">Chat now</span>
        <span className="block text-base font-bold text-white">WhatsApp</span>
      </span>
    </a>
  );
};

export default FloatingWhatsAppWidget;
